import { useTheme } from "@mui/material";

import { DonutChart } from "components/modules/charts/DonutChart";
import { useDDFilter } from "components/modules/disinfectionFilter/DisinfectionFilterPanel";
import { graphql } from "gql";
import { DisinfectionFilter } from "gql/graphql";
import { FormattedMessage } from "react-intl";
import { useQueryWithSnack } from "utils/useQueryWithSnack";

// TODO: Querying all disinfections to populate a donut chart is crazy. Fix this
const QUERY = graphql(`
  query disinfectionsInterrupted($filter: DisinfectionFilter!) {
    disinfectionsComplete(filter: $filter) {
      complete
      incomplete
      interrupted
    }
  }
`);

interface Props {
  hiddenFilter?: DisinfectionFilter;
}

export const DisinfectionsInterruptedChart = ({ hiddenFilter }: Props) => {
  const theme = useTheme();

  const [filterParams] = useDDFilter();

  const { data } = useQueryWithSnack(QUERY, {
    variables: {
      filter: {
        ...filterParams,
        ...hiddenFilter,
      },
    },
    skip: !filterParams?.timeSpan,
  });

  return (
    <DonutChart
      header={
        <FormattedMessage
          id="disinfections-interrupted"
          defaultMessage="Disinfections Interrupted"
        />
      }
      description={
        <FormattedMessage
          id="disinfections-interrupted-description"
          defaultMessage="Number of disinfections which experienced interruptions"
        />
      }
      count={data?.disinfectionsComplete?.interrupted ?? 0}
      totalCount={
        (data?.disinfectionsComplete?.complete ?? 0) +
        (data?.disinfectionsComplete?.incomplete ?? 0)
      }
      paperProps={{
        style: {
          backgroundColor: theme.palette.warning.main,
        },
      }}
      paperTextColor="white"
      donutSize={112}
      donutColor="white"
      donutBackgroundColor="rgba(24, 28, 50, 0.05)"
      donutTextColor="white"
      dataUnknown={data === undefined}
    />
  );
};
